import React, { useState, useRef } from 'react';
import { Link } from 'gatsby';

import { Module, List, News, Pagination } from './styles';
import Wrapper from '../../ui/Wrappers';

import OImage from '../OImage';
import Chevron from '-!svg-react-loader!../../ui/svgs/icon-chevron.svg';

interface INews {
  key: string;
  title: string;
  text: string;
  date: string;
  imageUrl: any;
  imageAlt?: string;
  link: any;
}

interface IProps {
  news: INews[];
}

const NewsList = ({ news }: IProps) => {
  const topRef = useRef(null);
  const pageElements = 6;
  const totalPages = Math.ceil(news.length / pageElements);
  const [currentPage, setCurrentPage] = useState(0);

  let currentNews = [];
  for (let i = 0; i < pageElements; i++) {
    news.length > i + currentPage * pageElements &&
      currentNews.push(news[i + currentPage * pageElements]);
  }

  return (
    <Module>
      <Wrapper ref={topRef} as={List} size="reader">
        {currentNews.map(n => {
          let splittedUrl, imageName, query, baseUrl, finalUrl;

          const customEncodeURIComponent = (str) => {
            return encodeURIComponent(str)
              .replace(/\(/g, '%28')
              .replace(/\)/g, '%29')
              .replace(/'/g, '%27')
              .replace(/!/g, '%21')
              .replace(/\*/g, '%2A');
          };

          const getImageUrl = (links, size) => {
            if (links && links[size] && links[size].href) {
              return links[size].href;
            }
            return null;
          };

          const href = getImageUrl(n.imageUrl, 'xsmall_webp')
            || getImageUrl(n.imageUrl, 'xsmall');

          if (href) {
            splittedUrl = href.split('/');
            imageName = splittedUrl[splittedUrl.length - 1];
            query = imageName.split('?')[1];
            baseUrl = href.replace(imageName, '');
            imageName = imageName.replace('?' + query, '');
            finalUrl = baseUrl + customEncodeURIComponent(imageName) + '?' + query;
          }

          return (
            <News>
              <div className="contentZone">
                <h2 className="newsTitle">
                  <Link
                    to={n.link?.uri}
                    data-gtm-event
                    data-gtm-category="cta"
                    data-gtm-action={'noticias'}
                    data-gtm-label={`${n.title}_${n.link?.uri}`}>
                    {n.title}
                  </Link>
                </h2>
                <div className="abstract">{n.text}</div>
                <div className="date">{n.date}</div>
              </div>
              <div className="imageZone">
                <Link
                  to={n.link?.uri}
                  aria-label={`This image is a preview of the news main image`}
                  data-gtm-event
                  data-gtm-category="cta"
                  data-gtm-action={'noticias'}
                  data-gtm-label={`${n.title}_${n.link?.uri}`}>
                  <OImage
                    aspectRatio={3 / 2}
                    alt={n?.imageAlt || ''}
                    className="image"
                    bg={
                      finalUrl
                    }
                  />
                </Link>
              </div>
            </News>
          )
        })}
      </Wrapper>
      <Pagination>
        <div
          className={`btn double reverse ${currentPage > 0 ? 'active' : ''}`}
          onClick={() =>
            currentPage > 0 &&
            (setCurrentPage(0), window.scrollTo({ top: topRef?.current?.offsetTop - 64 }))
          }>
          <Chevron className="svg" />
          <Chevron className="svg" />
        </div>
        <div
          className={`btn reverse ${currentPage > 0 ? 'active' : ''}`}
          onClick={() =>
            currentPage > 0 &&
            (setCurrentPage(currentPage - 1),
              window.scrollTo({ top: topRef?.current?.offsetTop - 64 }))
          }>
          <Chevron className="svg" />
        </div>
        <div className="currentPage">{`${currentPage + 1}/${totalPages}`}</div>
        <div
          className={`btn ${currentPage < totalPages - 1 ? 'active' : ''}`}
          onClick={() =>
            currentPage < totalPages - 1 &&
            (setCurrentPage(currentPage + 1),
              window.scrollTo({ top: topRef?.current?.offsetTop - 64 }))
          }>
          <Chevron className="svg" />
        </div>
        <div
          className={`btn double ${currentPage < totalPages - 1 ? 'active' : ''}`}
          onClick={() =>
            currentPage < totalPages - 1 &&
            (setCurrentPage(totalPages - 1),
              window.scrollTo({ top: topRef?.current?.offsetTop - 64 }))
          }>
          <Chevron className="svg" />
          <Chevron className="svg" />
        </div>
      </Pagination>
    </Module>
  );
};

export default NewsList;
